export const LIST_DOCUMENT = 'LIST_DOCUMENT';
export const CREATE_DOCUMENT = 'CREATE_DOCUMENT';
export const SHOW_DOCUMENT = 'SHOW_DOCUMENT';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const LIST_DOCUMENT_CATEGORY = 'LIST_DOCUMENT_CATEGORY';
export const CREATE_DOCUMENT_CATEGORY = 'CREATE_DOCUMENT_CATEGORY';
export const SHOW_DOCUMENT_CATEGORY = 'SHOW_DOCUMENT_CATEGORY';
export const UPDATE_DOCUMENT_CATEGORY = 'UPDATE_DOCUMENT_CATEGORY';
export const DELETE_DOCUMENT_CATEGORY = 'DELETE_DOCUMENT_CATEGORY';
export const ADD_DELETE = 'ADD_DELETE';
export const CHECK_ALL = 'CHECK_ALL';
export const ADD_DATA_REMOVE_DOCUMENT = 'ADD_DATA_REMOVE_DOCUMENT';
